import { Component, Input, OnInit } from '@angular/core';
// import { Client } from 'src/app/models/Candidate';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Candidate } from 'src/app/models/Candidate';
import { IClientStatus } from 'src/types/client/clients';
@Component({
  selector: 'app-client-status',
  templateUrl: './client-status.component.html',
  styleUrls: ['./client-status.component.css']
})
export class ClientStatusComponent implements OnInit {
  @Input() clientID: string = '';
  @Input() clientCorporation: string = '';
  statusData: IClientStatus| null = null;
  displayLoader: boolean = true;
  page: any = 1;
  pageSize: any = 10;
  collectionSize = 10;
  loading: boolean = true;
  query: any ;

  constructor(private http: HttpClient ) { }

  ngOnInit(): void {
    this.CandidateStatusUpdate()

  }

  CandidateStatusUpdate() {
    const url = `${environment.apiConfig.uri}/admin/AdminClientContact/GetClientStatus?clientCorporationId=${this.clientCorporation}&clientId=${this.clientID}`;
    this.http.get<{ data: IClientStatus }>(url, {}).subscribe(
        async (response) => {
          this.statusData = response.data;
          this.displayLoader = false;
        },
        (error) => {
          console.error('Error updating client status:', error);
          this.displayLoader = false;
        }
      );
  }

}
